export const copyToClipboard = (text: string) => {
    const listener = (e: ClipboardEvent) => {
        e.clipboardData.setData('text/plain', text);
        e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
};

export const copyElementToClipboard = (element: HTMLElement) => {
    const r = document.createRange();
    r.selectNode(element);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
};

export const getElementText = (element: HTMLElement) => {
    const r = document.createRange();
    r.selectNode(element);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    const str = r.toString();
    window.getSelection().removeAllRanges();
    return str;
};
